import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            字母索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">
            按首字母快速定位你想看的剧集，全集追剧更方便
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group flex items-start gap-4 bg-white rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 flex-shrink-0">
                <span className="text-xl md:text-2xl font-label font-bold">{item.letter}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 group-hover:text-primary-500 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{item.desc}</p>
                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}